(() => {
  if (window.zooPurchaseLabelsLoaded) return;
  window.zooPurchaseLabelsLoaded = true;

  const controllers = new Map();

  class PurchaseLabels {
    constructor(productInfo) {
      this.productInfo = productInfo;
      this.frame = null;
      this.schedule = this.schedule.bind(this);
      productInfo.addEventListener('change', this.schedule);
      productInfo.addEventListener('input', this.schedule);
      this.observer = new MutationObserver(this.schedule);
      this.observer.observe(productInfo, {
        subtree: true,
        childList: true,
        characterData: true,
        attributes: true,
        attributeFilter: ['value', 'checked', 'disabled', 'aria-disabled']
      });
      this.schedule();
    }

    schedule() {
      if (this.frame !== null) return;
      this.frame = requestAnimationFrame(() => {
        this.frame = null;
        this.update();
      });
    }

    update() {
      const copy = this.productInfo.closest('[data-zoo-purchase-labels]');
      const oneTimeLabel = copy?.dataset.oneTimeLabel || window.variantStrings?.addToCart || 'Добави в количка';
      const subscriptionLabel = copy?.dataset.subscriptionLabel || window.variantStrings?.buySubscription || 'Купи с абонамент';

      this.productInfo.querySelectorAll('product-form form').forEach((form) => {
        // Read the actual enabled form fields; never select or modify a plan.
        const subscriptionSelected = Array.from(form.elements).some((field) => {
          if (field.name !== 'selling_plan' || field.disabled) return false;
          if (['radio', 'checkbox'].includes(field.type) && !field.checked) return false;
          return /^\d+$/.test(field.value.trim()) && Number(field.value) > 0;
        });
        const label = subscriptionSelected ? subscriptionLabel : oneTimeLabel;

        form.querySelectorAll('[data-add-to-cart]').forEach((button) => {
          // The native variant controller owns unavailable and loading states.
          if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
          const text = button.querySelector('[data-add-to-cart-text]');
          if (!text) return;
          if (text.textContent.trim() !== label) text.textContent = label;
          if (button.getAttribute('aria-label') !== label) button.setAttribute('aria-label', label);
        });
      });
    }

    disconnect() {
      this.productInfo.removeEventListener('change', this.schedule);
      this.productInfo.removeEventListener('input', this.schedule);
      this.observer.disconnect();
      if (this.frame !== null) cancelAnimationFrame(this.frame);
    }
  }

  const initialize = (scope) => {
    const products = scope.matches?.('product-information') ? [scope] : Array.from(scope.querySelectorAll('product-information'));
    products.forEach((productInfo) => {
      if (!controllers.has(productInfo)) controllers.set(productInfo, new PurchaseLabels(productInfo));
    });
  };

  initialize(document);
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
  document.addEventListener('shopify:section:unload', (event) => {
    controllers.forEach((controller, productInfo) => {
      if (event.target.contains(productInfo)) {
        controller.disconnect();
        controllers.delete(productInfo);
      }
    });
  });
})();
